import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import CreateRoleComponent from "../../../../component/System/Role/CreateRole";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  createRole,
  updateRole,
  fetchRoleById,
  fetchRoleMenuAccess,
  fetchAllMenus,
  initCreateRoleScreen,
} from "../../../../redux/actions/System/Role";

const CreateRoleContainer = (props) => {
  const {
    isLoading,
    isEdit,
    formFieldValueMap,
    isRoleDetailSuccess,
    isRoleMenuAccessSuccess,
    isRoleCreateSuccess,
    isRoleCreateError,
    isUpdateRoleSuccess,
    isUpdateRoleError,
    error,
    allMenusList,
    createRole,
    updateRole,
    fetchRoleById,
    fetchRoleMenuAccess,
    fetchAllMenus,
    initCreateRoleScreen,
  } = props;

  const { id } = useParams();

  useEffect(() => {
    const initialize = async () => {
      initCreateRoleScreen();
      await fetchAllMenus();
      if (isEdit && id) {
        await fetchRoleById({ id });
        await fetchRoleMenuAccess({ id });
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, id]);

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  const getToastProps = () => {
    if (isUpdateRoleSuccess || isRoleCreateSuccess) {
      const toastTitle = isEdit
        ? "Role updated successfully"
        : "Role created successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (isUpdateRoleError || isRoleCreateError) {
      const toastTitle = error || "Error while saving role";
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }

    return null;
  };

  const createRoleProps = {
    isEdit,
    formFieldValueMap,
    isRoleDetailSuccess,
    isRoleMenuAccessSuccess,
    isRoleCreateSuccess,
    isUpdateRoleSuccess,
    allMenusList,
    createRole,
    isLoading,
    updateRole,
  };

  const toastProps = getToastProps();

  return (
    <>
      {isLoading && renderProgressBar()}
      {toastProps && <EzToast {...toastProps} />}
      <CreateRoleComponent {...createRoleProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const roleReducer = state.roleReducer;
  return {
    isLoading: roleReducer?.isLoading,
    formFieldValueMap: roleReducer?.formFieldValueMap,
    isRoleDetailSuccess: roleReducer?.isRoleDetailSuccess,
    isRoleMenuAccessSuccess: roleReducer?.isRoleMenuAccessSuccess,
    isRoleCreateSuccess: roleReducer?.isRoleCreateSuccess,
    isRoleCreateError: roleReducer?.isRoleCreateError,
    isUpdateRoleSuccess: roleReducer?.isUpdateRoleSuccess,
    isUpdateRoleError: roleReducer?.isUpdateRoleError,
    allMenusList: roleReducer?.allMenusList,
    error: roleReducer?.error,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateRoleScreen: () => dispatch(initCreateRoleScreen()),
    createRole: (payload) => dispatch(createRole(payload)),
    updateRole: (payload) => dispatch(updateRole(payload)),
    fetchRoleById: (payload) => dispatch(fetchRoleById(payload)),
    fetchRoleMenuAccess: (payload) => dispatch(fetchRoleMenuAccess(payload)),
    fetchAllMenus: () => dispatch(fetchAllMenus()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateRoleContainer);
